/* ==========================================================================
   Bundle buy
   Renders multi-product bundle selection on the PDP and adds every selected
   variant to the cart in a single /cart/add.js request.
   ========================================================================== */
(function () {
  'use strict';

  /* ---------------------------------------------------------------------
     Money formatting (standard Shopify helper)
     --------------------------------------------------------------------- */
  function formatMoney(cents, format) {
    var formatString = format || '${{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = formatString.match(placeholderRegex);

    if (!match) return formatString;
    if (typeof cents === 'string') cents = cents.replace('.', '');

    function withDelimiters(number, precision, thousands, decimal) {
      precision = typeof precision === 'undefined' ? 2 : precision;
      thousands = typeof thousands === 'undefined' ? ',' : thousands;
      decimal = typeof decimal === 'undefined' ? '.' : decimal;

      if (isNaN(number) || number === null) return '0';

      var fixed = (number / 100.0).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var fraction = parts[1] ? decimal + parts[1] : '';

      return whole + fraction;
    }

    var value = '';

    switch (match[1]) {
      case 'amount':
        value = withDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = withDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = withDelimiters(cents, 0, ' ', '.');
        break;
      case 'amount_with_space_separator':
        value = withDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        value = withDelimiters(cents, 2, ' ', '.');
        break;
      default:
        value = withDelimiters(cents, 2);
    }

    return formatString.replace(placeholderRegex, value);
  }

  /* ---------------------------------------------------------------------
     Controller
     --------------------------------------------------------------------- */
  function BundleBuy(root) {
    this.root = root;
    this.loading = false;
    this.selected = [];

    var dataEl = root.querySelector('[data-bundle-data]');
    if (!dataEl) return;

    try {
      this.data = JSON.parse(dataEl.textContent);
    } catch (error) {
      return;
    }

    if (!this.data || !this.data.products || !this.data.products.length) return;

    this.itemEls = root.querySelectorAll('[data-bundle-item]');
    this.totalEl = root.querySelector('[data-bundle-total]');
        this.compareEl = root.querySelector('[data-bundle-compare]');
    this.soldOutBadgeEl = root.querySelector('[data-bundle-soldout-badge]');
    this.addButton = root.querySelector('[data-bundle-add]');
    this.addText = root.querySelector('[data-bundle-add-text]');
    this.buyButton = root.querySelector('[data-bundle-buy-now]');
    this.errorEl = root.querySelector('[data-bundle-error]');
    this.quantityInput = root.querySelector('[data-bundle-buttons] .quantity__input');

    this.ready = true;
    this.bindEvents();
    this.update();
  }

  BundleBuy.prototype.bindEvents = function () {
    var self = this;

    this.root.addEventListener('change', function (event) {
      var target = event.target;
      if (!target) return;
      if (
        target.hasAttribute('data-bundle-option-input') ||
        target.classList.contains('quantity__input')
      ) {
        self.update();
      }
    });

    if (this.addButton) {
      this.addButton.addEventListener('click', function () {
        self.submit(false);
      });
    }

    if (this.buyButton) {
      this.buyButton.addEventListener('click', function () {
        self.submit(true);
      });
    }
  };

  /* --- Selection helpers ------------------------------------------------ */

  BundleBuy.prototype.getSelectedValues = function (itemEl) {
    if (!itemEl) return null;
    var inputs = itemEl.querySelectorAll('[data-bundle-option-input]:checked');
    var values = [];
    for (var i = 0; i < inputs.length; i++) values.push(inputs[i].value);
    return values;
  };

  BundleBuy.prototype.findVariant = function (product, values) {
    if (!values) return null;
    for (var i = 0; i < product.variants.length; i++) {
      var variant = product.variants[i];
      var matched = true;
      for (var j = 0; j < values.length; j++) {
        if (variant.options[j] !== values[j]) {
          matched = false;
          break;
        }
      }
      if (matched) return variant;
    }
    return null;
  };

  BundleBuy.prototype.getVariantFor = function (product, itemEl) {
    // Single-variant product, or picker block not rendered — fall back safely.
    if (product.has_only_default_variant || !itemEl) {
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].available) return product.variants[i];
      }
      return product.variants[0] || null;
    }

    var values = this.getSelectedValues(itemEl);
    if (!values || values.length !== product.options.length) return null;
    return this.findVariant(product, values);
  };

  /* --- Option availability (strike-through unavailable combos) ---------- */

  BundleBuy.prototype.markOptionAvailability = function (product, itemEl) {
    if (!itemEl || product.has_only_default_variant) return;

    var self = this;
    var current = this.getSelectedValues(itemEl);
    if (!current || current.length !== product.options.length) return;

    var fieldsets = itemEl.querySelectorAll('[data-bundle-option]');

    for (var position = 0; position < fieldsets.length; position++) {
      var fieldset = fieldsets[position];
      var inputs = fieldset.querySelectorAll('[data-bundle-option-input]');

      for (var i = 0; i < inputs.length; i++) {
        var input = inputs[i];
        var test = current.slice();
        test[position] = input.value;

        var match = self.findVariant(product, test);
        var soldOut = !match || !match.available;
        var label = input.nextElementSibling;

        if (label) label.classList.toggle('bundle-option__value--soldout', soldOut);
      }

      var selectedEl = fieldset.querySelector('[data-bundle-option-selected]');
      var checked = fieldset.querySelector('[data-bundle-option-input]:checked');
      if (selectedEl && checked) selectedEl.textContent = checked.value;
    }
  };

  /* --- Render ----------------------------------------------------------- */

  BundleBuy.prototype.update = function () {
    if (!this.ready) return;

    var self = this;
    var total = 0;
    var compareTotal = 0;
        var hasCompare = false;
    var allValid = true;
    var allFound = true;

    this.data.products.forEach(function (product, index) {
      var itemEl = self.itemEls[index];
      var variant = self.getVariantFor(product, itemEl);

      self.selected[index] = variant;
      self.markOptionAvailability(product, itemEl);

      var priceEl = itemEl ? itemEl.querySelector('[data-bundle-item-price]') : null;
      var statusEl = itemEl ? itemEl.querySelector('[data-bundle-item-unavailable]') : null;

            if (!variant) allFound = false;
      if (variant && !variant.available) allValid = false;

      if (variant) {
        total += variant.price;
        var compare =
          variant.compare_at_price && variant.compare_at_price > variant.price
            ? variant.compare_at_price
            : variant.price;
        compareTotal += compare;
        if (compare !== variant.price) hasCompare = true;

        if (priceEl) priceEl.textContent = formatMoney(variant.price, self.data.money_format);
        if (statusEl) statusEl.hidden = true;
      } else {
        allValid = false;
        if (priceEl) priceEl.textContent = '';
        if (statusEl) {
          statusEl.textContent = variant
            ? statusEl.getAttribute('data-sold-out') || ''
            : statusEl.getAttribute('data-unavailable') || '';
          statusEl.hidden = false;
        }
      }
    });

        if (this.totalEl) {
      this.totalEl.textContent = allFound ? formatMoney(total, this.data.money_format) : '';
    }

    if (this.compareEl) {
      if (allFound && hasCompare) {
        this.compareEl.textContent = formatMoney(compareTotal, this.data.money_format);
        this.compareEl.hidden = false;
      } else {
        this.compareEl.hidden = true;
      }
    }

        if (this.soldOutBadgeEl) {
      this.soldOutBadgeEl.hidden = allValid;
    }

    this.setEnabled(allFound && allValid);
  };

  BundleBuy.prototype.setEnabled = function (enabled) {
    if (this.loading) return;

    if (this.addButton) {
      this.addButton.disabled = !enabled;
      this.addButton.setAttribute('aria-disabled', String(!enabled));
    }
    if (this.buyButton) {
      this.buyButton.disabled = !enabled;
      this.buyButton.setAttribute('aria-disabled', String(!enabled));
    }
    if (this.addText) {
      this.addText.textContent = enabled
        ? this.addText.getAttribute('data-add') || ''
        : this.addText.getAttribute('data-sold-out') || '';
    }
  };

  BundleBuy.prototype.setLoading = function (loading) {
    this.loading = loading;

    if (this.addButton) {
      this.addButton.classList.toggle('loading', loading);
      this.addButton.disabled = loading;
      this.addButton.setAttribute('aria-disabled', String(loading));
      var spinner = this.addButton.querySelector('.loading__spinner');
      if (spinner) spinner.classList.toggle('hidden', !loading);
    }
    if (this.buyButton) {
      this.buyButton.disabled = loading;
      this.buyButton.setAttribute('aria-disabled', String(loading));
    }
  };

  /* --- Errors ----------------------------------------------------------- */

  BundleBuy.prototype.showError = function (message) {
    if (!this.errorEl) return;
    this.errorEl.textContent = message || this.errorEl.getAttribute('data-generic-error') || '';
    this.errorEl.hidden = false;
  };

  BundleBuy.prototype.hideError = function () {
    if (!this.errorEl) return;
    this.errorEl.hidden = true;
    this.errorEl.textContent = '';
  };

  /* --- Quantity --------------------------------------------------------- */

  BundleBuy.prototype.getQuantity = function () {
    var value = this.quantityInput ? parseInt(this.quantityInput.value, 10) : 1;
    if (!value || value < 1 || isNaN(value)) return 1;
    return value;
  };

  /* --- Submit ----------------------------------------------------------- */

  BundleBuy.prototype.submit = function (goToCheckout) {
    if (!this.ready || this.loading) return;

    var self = this;
    var quantity = this.getQuantity();
    var items = [];
    var valid = true;

    this.data.products.forEach(function (product, index) {
      var variant = self.selected[index];
      if (!variant || !variant.available) {
        valid = false;
        return;
      }
      items.push({ id: variant.id, quantity: quantity });
    });

    if (!valid || !items.length) {
      this.showError(this.errorEl ? this.errorEl.getAttribute('data-select-error') : '');
      return;
    }

    this.hideError();
    this.setLoading(true);

    var body = { items: items };
    var cart =
      document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (section) {
        return section.id;
      });
      body.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(document.activeElement);
      }
    }

    fetch(this.data.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript'
      },
      body: JSON.stringify(body)
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          self.showError(response.description || response.message);
          return;
        }

        if (goToCheckout) {
          window.location.href = self.data.checkout_url;
          return;
        }
        var parentModal = self.root.closest('.bundle-save-modal');
        if (parentModal) {
          parentModal.removeAttribute('open');
          document.body.classList.remove('overflow-hidden');
        }

        if (cart && typeof cart.renderContents === 'function') {
          cart.classList.remove('is-empty');
          cart.renderContents(response);

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'bundle-buy',
              productVariantId: items[0].id,
              cartData: response
            });
          }
        } else {
          window.location.href = self.data.cart_url;
        }
      })
      .catch(function () {
        self.showError('');
      })
      .finally(function () {
        if (goToCheckout) return;
        self.setLoading(false);
        self.update();
      });
  };

  /* ---------------------------------------------------------------------
     Init
     --------------------------------------------------------------------- */
  function initAll() {
    var roots = document.querySelectorAll('[data-bundle]');
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].bundleBuy) continue;
      roots[i].bundleBuy = new BundleBuy(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  if (!window.__bundleBuyBound) {
    window.__bundleBuyBound = true;

    document.addEventListener('shopify:section:load', initAll);

    // Quick-add modal injects the PDP markup after page load — catch it here.
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (
            (node.matches && node.matches('[data-bundle]')) ||
            (node.querySelector && node.querySelector('[data-bundle]'))
          ) {
            initAll();
            return;
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }
})();